/**
 * Chuỗi dùng chung của module `tro-ly-ai` (khung màn, vùng dữ liệu, lưới nguồn) — tạm tách tệp khi dựng song song,
 * sẽ gộp vào `vi.ts`.
 */
export const viChung = {
  troLyAi: {
    xemCheoTieuDe: 'Bạn đang xem giao diện của tenant',
    xemCheoMo: 'Trợ lý AI chạy trên dữ liệu của một tổ chức. Đăng nhập bằng tài khoản của tổ chức để xem dữ liệu thật.',
    chuaSanSangTieuDe: 'Trợ lý AI chưa sẵn sàng',
    chuaSanSangMo: 'Module Trợ lý AI chưa chạy trên máy chủ này. Thử lại sau hoặc báo đội vận hành.',
    tuChoiTieuDe: 'Câu lệnh bị chặn',
    lamMoi: 'Làm mới',
    dong: '{{so}} dòng',
    luoiNguon: {
      timNguon: 'Tìm nguồn theo tên, mã hoặc mô tả',
      moiLoai: 'Mọi loại nguồn',
      loaiCsdl: 'CSDL',
      loaiGraphql: 'GraphQL',
      loaiApi: 'API',
      loaiCsdlVaGraphql: 'CSDL / GraphQL',
      demNguon: '{{shown}}/{{total}} nguồn',
      rongTieuDe: 'Chưa có nguồn nào',
      rongMoTa: 'Thêm nguồn ở Kết nối nguồn trước, rồi quay lại đây.',
      sangKetNoi: 'Sang Kết nối nguồn',
      khongKhopTieuDe: 'Không nguồn nào khớp',
      danhSachNguon: 'Danh sách nguồn dữ liệu',
    },
    trangThaiNguon: {
      draft: 'Bản nháp',
      connected: 'Đã kết nối',
      ready: 'Sẵn sàng',
      error: 'Lỗi',
    },
    kieuHien: {
      nhan: 'Cách hiển thị',
      luoi: 'Dạng lưới',
      danhSach: 'Dạng danh sách',
    },
  },
} as const;
